<template>
  <div class="design-card" :class="checked ? 'active' : ''" @click="checked = !checked">
    <div v-if="design.data && (design.data['acf-product-options-design-image'] || design.data['acf-product-options-design-textarea'] || design.data['acf-product-options-design-file'])" class="info-container" @mouseenter.stop="hovered = true" @mouseleave.stop="hovered = false" @click.stop>
      <img src="@/assets/img/info.svg" class="info-icon">
      <Transition name="slide-fade" mode="out-in">
        <div v-if="hovered" class="preview-area" :class="!design.data['acf-product-options-design-image'] ? 'no-image' : ''">
          <img v-if="design.data['acf-product-options-design-image']" :src="design.data['acf-product-options-design-image'].url" class="preview-image">
          <div v-if="design.data['acf-product-options-design-textarea']" class="preview-description">{{design.data['acf-product-options-design-textarea']}}</div>
          <a v-if="design.data['acf-product-options-design-file']" class="specs-link" target="_blank" :href="design.data['acf-product-options-design-file'].url" :download="design.data['acf-product-options-design-title']">
            <div class="specs-button">
              <p>Specs</p><img src="@/assets/img/download-black.svg" alt="">
            </div>
          </a>
        </div>
      </Transition>
    </div>
    <h2 class="design-title">{{design.label}}</h2>
  </div>
</template>
<script setup>
import { ref, watch, onMounted } from 'vue'
import { ProductState } from './state'
const { addDesignOption, removeDesignOption, designOptions, toggleDesignGroupOption, designGroupSelections } = ProductState()

const props = defineProps(['design', 'group'])
const checked = ref(false)
const hovered = ref(false)

onMounted(() => {
  if (props.group) {
    const groupSel = designGroupSelections[props.group]
    if (Array.isArray(groupSel) && groupSel.find(x => x.value === props.design.value)) {
      checked.value = true
    }
  } else {
    if (designOptions.value.find(x => x.value === props.design.value)) {
      checked.value = true
    }
  }
})

watch(checked, (next, prev) => {
  if (props.group) {
    toggleDesignGroupOption(props.group, props.design)
  } else {
    if (next) {
      addDesignOption(props.design)
    } else {
      removeDesignOption(props.design)
    }
  }
})

</script>
<style lang="scss" scoped>
  .design-card {
    @apply bg-white rounded-xl p-3 pt-4 relative cursor-pointer transition-shadow duration-300 ease-in-out flex flex-col;
    &::before {
      @apply absolute content-[''] h-2 w-2 rounded-full bg-ore_orange top-2 left-3 opacity-0 transition-opacity duration-300 ease-in-out;
    }
    &.active {
      @apply shadow-primaryshade/30 shadow-lg;
    }
    &.active::before {
      @apply opacity-100;
    }
    &:hover {
      @apply shadow-primaryshade/30 shadow-lg;
    }
    .info-container {
      @apply absolute top-2 right-2;
      .info-icon {
        @apply w-5 h-5 cursor-pointer opacity-60 hover:opacity-100 transition-opacity duration-200;
      }
      .preview-area {
        @apply absolute right-0 top-8 w-72 flex flex-col bg-white p-4 shadow-lg rounded-md transition-all duration-300 ease-in-out z-[8];
        &.no-image {
          @apply w-56;
        }
        .preview-image {
          @apply mb-4 rounded;
        }
        .preview-description {
          @apply text-sm leading-relaxed;
        }
        .specs-link {
          @apply flex w-fit self-end hover:scale-95 transition mt-4;
          .specs-button {
            @apply cursor-pointer flex items-center border border-black rounded-full w-fit px-3 py-1;
            p { @apply mr-4 text-[14px]; }
          }
        }
      }
    }
    .design-title {
      @apply text-base leading-tight pr-6;
    }
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }
</style>
